import styled from 'styled-components';
import { Modal } from '../../../atoms/Modal/Modal';
import Button from '../../../atoms/Button/Button';
import BulkFailedWebhookModal from './BulkFailedWebhookModal';
import { useWebhooksStore } from '../../../../store/admin/webhooks/webhooksStore';

export const BulkFailedWebhookActions = () => {
    const { bulkAction, selectedFailedWebhooks, clearBulkFailedWebhook, setBulkAction } =
        useWebhooksStore();

    const hideBulkFailedWebhookModal = () => {
        clearBulkFailedWebhook();
        setBulkAction({ action: '', failedWebhooks: [] });
    };

    return (
        <>
            <BulkButtons>
                <Button
                    data-testid="bulk-action-resend-button"
                    onClick={() =>
                        setBulkAction({
                            action: 'Resend',
                            failedWebhooks: selectedFailedWebhooks,
                        })
                    }
                    disabled={selectedFailedWebhooks.length === 0}
                >
                    Resend selected
                </Button>
                <Button
                    data-testid="bulk-action-delete-button"
                    onClick={() =>
                        setBulkAction({
                            action: 'Delete',
                            failedWebhooks: selectedFailedWebhooks,
                        })
                    }
                    disabled={selectedFailedWebhooks.length === 0}
                >
                    Delete selected
                </Button>
            </BulkButtons>

            {bulkAction && (
                <Modal
                    medium
                    isShown={bulkAction.action.length > 0}
                    hide={hideBulkFailedWebhookModal}
                >
                    <BulkFailedWebhookModal hide={hideBulkFailedWebhookModal} />
                </Modal>
            )}
        </>
    );
};

const BulkButtons = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-end;
`;
